import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { PROFILE_PICTURES } from '../../constants/profilePictures';
import { UserService, BusinessService } from '../../services/index';

async function getEntity (payload) {
  const entityService = new UserService();
  const entityResponse = await entityService.getByParameters(payload);

  if (!entityResponse || !entityResponse.result) {
    return null;
  }

  return entityResponse.result;
}

async function updateEntity (payload, isAdmin) {
  const entityService = new UserService();
  const entityResponse = await entityService.update(payload);

  if (!entityResponse || !entityResponse.result) {
    return null;
  }

  if (!entityResponse || !entityResponse.result) {
    return;
  }

  console.log(entityResponse);

  if (isAdmin) {
    window.location.assign('/admin/user');
  } else {
    window.location.assign('/business/user');
  }
}

function UserUpdate () {
  const { isAdmin, setPageName } = useOutletContext();
  const params = Object.fromEntries(new URLSearchParams(window.location.search));

  useEffect(() => {
    setPageName('Usuarios');
  }, []);

  const profilePictures = PROFILE_PICTURES;

  const [id, setId] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [dni, setDni] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('');
  const [businessId, setBusinessId] = useState('');
  const [profilePicUri, setProfilePicUri] = useState('');
  const [positionName, setPositionName] = useState('');
  const [isDashboardPinned, setIsDashboardPinned] = useState('');
  const [roleList, setRoleList] = useState([]);
  const [businessList, setBusinessList] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    updateEntity({
      identity: id,
      id,
      firstname,
      lastname,
      email,
      password,
      dni,
      phone,
      role: roleList.find(_role => role === _role.name),
      business_id: businessId,
      profile_pic_uri: profilePicUri,
      position_name: positionName,
      is_dashboard_pinned: isDashboardPinned
    }, isAdmin);
  }

  useEffect(() => {
    const fetchData = async () => {
      const entity = await getEntity({
        id: params.id
      }, UserService);

      const roles = await getEntity({
        roles: true
      }, UserService);

      const businessList = await getEntity({
        all: true
      }, BusinessService);

      setId(entity.id);
      setFirstname(entity.firstname);
      setLastname(entity.lastname);
      setEmail(entity.email);
      setPassword(entity.password);
      setDni(entity.dni);
      setPhone(entity.phone);
      setRole(entity.role.name);
      setBusinessId(entity.business_id);
      setProfilePicUri(entity.profile_pic_uri);
      setPositionName(entity.position_name);
      setIsDashboardPinned(entity.is_dashboard_pinned);
      setRoleList(roles);
      setBusinessList(businessList);
      console.log(entity);
      console.log(roleList);
      console.log(businessList);
    }

    fetchData().catch(console.error);
  }, []);

  return (
    <section className="container-fluid">
      <div className="row">
        <section className="col-12">
          <article className="card">
            <div className="card-body">
              <h4 className="header-title">Editar usuario</h4>
              <p className="text-muted font-13">Aquí podrás editar el usuario con la siguiente información.</p>

              <form onSubmit={e => { handleSubmit(e) }} autoComplete="off">
                <div className="row">
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="text" className="form-control" id="input-firstname" placeholder="Escribe aquí los nombres"
                      value={firstname}
                      onChange={e => setFirstname(e.target.value)} />
                    <label htmlFor="input-firstname" className="form-label">Nombres</label>
                  </div>
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="text" className="form-control" id="input-lastname" placeholder="Escribe aquí los apellidos"
                      value={lastname}
                      onChange={e => setLastname(e.target.value)} />
                    <label htmlFor="input-lastname" className="form-label">Apellidos</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="email" className="form-control" id="input-email" placeholder="Escribe aquí el email"
                      value={email}
                      onChange={e => setEmail(e.target.value)} />
                    <label htmlFor="input-email" className="form-label">Email</label>
                  </div>
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="password" className="form-control" id="input-password" placeholder="Escribe aquí la contraseña"
                      value={password}
                      onChange={e => setPassword(e.target.value)} />
                    <label htmlFor="input-password" className="form-label">Contraseña</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="text" className="form-control" id="input-dni" placeholder="Escribe aquí la identificación nacional"
                      value={dni}
                      onChange={e => setDni(e.target.value)} />
                    <label htmlFor="input-dni" className="form-label">Identificación</label>
                  </div>
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="tel" className="form-control" id="input-phone" placeholder="Escribe aquí el teléfono de contacto"
                      value={phone}
                      onChange={e => setPhone(e.target.value)} />
                    <label htmlFor="input-phone" className="form-label">Teléfono</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3 form-floating">
                    <select id="input-role" className="form-select"
                      value={role}
                      onChange={e => setRole(e.target.value)}>
                      <option>Selecciona...</option>
                      {roleList.map((role) => (
                        <option key={role.id} value={role.name}>{role.title}</option>
                      ))}
                    </select>
                    <label htmlFor="input-role" className="form-label">Rol</label>
                  </div>
                  <div className="col-md-6 mb-3 form-floating">
                    <select id="input-business_id" className="form-select"
                      disabled={role === 'admin'}
                      value={businessId}
                      onChange={e => setBusinessId(e.target.value)}>
                      <option>Selecciona...</option>
                      {businessList.map((business) => (
                        <option key={business.id} value={business.id}>{business.name}</option>
                      ))}
                    </select>
                    <label htmlFor="input-business_id" className="form-label">Negocio</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3 form-floating">
                    <select id="input-profile_pic_uri" className="form-select"
                      value={profilePicUri}
                      onChange={e => setProfilePicUri(e.target.value)}>
                      <option>Selecciona...</option>
                      {profilePictures.map((picture) => (
                        <option key={picture.key} value={picture.uri}>{picture.name}</option>
                      ))}
                    </select>
                    <label htmlFor="input-profile_pic_uri" className="form-label">Foto de perfil</label>
                  </div>
                  <div className="col-md-6 mb-3 form-floating">
                    <input type="text" className="form-control" id="input-position_name" placeholder="Escribe aquí el cargo"
                      value={positionName}
                      onChange={e => setPositionName(e.target.value)} />
                    <label htmlFor="input-position_name" className="form-label">Cargo</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3 form-floating">
                    <div className="form-check form-switch">
                      <input type="checkbox" className="form-check-input" id="input-is_dashboard_pinned"
                        value={isDashboardPinned}
                        onChange={e => setIsDashboardPinned(e.target.checked)} />
                      <label className="form-check-label" htmlFor="input-is_dashboard_pinned">Agregar al dashboard</label>
                    </div>
                  </div>
                </div>

                <div className="d-flex">
                  <button type="submit" className="btn btn-primary waves-effect waves-light me-1">Guardar</button>
                  <button type="button" className="btn btn-danger waves-effect waves-light ms-1">Cancelar</button>
                </div>

              </form>

            </div>
          </article>
        </section>
      </div>
    </section>
  );
}

export default UserUpdate;